import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/page/Carrotchinese/index"),
    meta: {
      title: "당근중국어",
      metaInfo: [
        {
          name: "naver-site-verification",
          content: "6c0a36e88d1d9ece5777f5652f96b246d70c18fb",
        },
        {
          name: "facebook-domain-verification",
          content: "lyceoxwtl9uotvzyidyj5vp8ylkmud",
        },
        {
          name: "keywords",
          content:
            "전화중국어, 화상중국어, 중국어회화, 당근중국어, 당근주니어중국어",
        },
        {
          name: "description",
          content:
            "당근 중국어 티칭경력 5년 이상의 차별화된 중국 원어민 선생님, 전화중국어, 화상중국어, 중국어회화 1:1맞춤수업, 다양한 주제와 체계적인 커리큘럼.",
        },
        { name: "viewport", content: "width=device-width" },
        { property: "og:type", content: "website" },
        { property: "og:title", name: "og:title", content: "당근중국어" },
        {
          property: "og:description",
          content:
            "당근 중국어 티칭경력 5년 이상의 차별화된 중국 원어민 선생님, 전화중국어, 화상중국어, 중국어회화 1:1맞춤수업, 다양한 주제와 체계적인 커리큘럼",
        },
        {
          property: "og:url",
          content: "https://www.carrotchinese.co.kr",
        },
        {
          property: "og:image",
          content: "https://www.carrotchinese.co.kr/img/img1-pc.a8813b79.png",
        },
      ],
    },
    name: "chinese",
  },
  {
    path: "/freeClass",
    component: () => import("@/page/Carrotchinese/freeClass"),
    meta: {
      title: "무료수업신청",
      metaInfo: [
        {
          name: "naver-site-verification",
          content: '1a9562186f5d32af6eeebf18306eeab7b2a02dcc',
        },
        {
          name: "facebook-domain-verification",
          content: "lyceoxwtl9uotvzyidyj5vp8ylkmud",
        },
        {
          name: "keywords",
          content:
            "전화중국어, 화상중국어, 중국어회화, 당근중국어, 당근주니어중국어",
        },
        {
          name: "description",
          content:
            "화상중국어 무료수업 신청, 중국어 티칭경력 5년 이상의 차별화된 중국 원어민 선생님과 무료수업으로 맞춤 중국어 레벨을 찾아보세요!",
        },
        { name: "viewport", content: "width=device-width" },
        { property: "og:type", content: "website" },
        {
          property: "og:title",
          content: "당근중국어 | 무료수업신청",
        },
        {
          property: "og:description",
          content:
            "화상중국어 무료수업 신청, 중국어 티칭경력 5년 이상의 차별화된 중국 원어민 선생님과 무료수업으로 맞춤 중국어 레벨을 찾아보세요!",
        },
        {
          property: "og:url",
          content: "https://www.carrotchinese.co.kr/freeClass",
        },
        {
          property: "og:image",
          content: "https://www.carrotchinese.co.kr/img/img1-pc.433fec12.png",
        },
      ],
    },
    name: "chineseleveltest",
  },
  {
    path: "/guide",
    component: () => import("@/page/Carrotchinese/guide"),
    meta: {
      title: "화상수업 방법",
    },
    name: "chineseguide",
  },
];

const carrotchinese = new VueRouter({
  mode: "history",
  routes,
});
/*
carrotchinese.afterEach((to, from) => {
  const title = to.meta.title === undefined ? "CarrotSolutions" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});
*/

/*
carrotchinese.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaInfo);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaInfo);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaInfo.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    //tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});
*/

export default carrotchinese;
